import { createSingleEntityStore, PickActions } from '@recruitee/ngrx';
import { DataSourceListItem } from '@recruitee/views-types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<DataSourceListItem[]>()('DataSourceList');

export const DataSourceListActions: PickActions<typeof actions, 'fetch'> = actions;

export {
  selectors as DataSourceListSelectors,
  reducer as DataSourceListReducer,
  namespace as DataSourceListNamespace,
};
